import React from 'react';
import { currencyLogo } from '../utils/currencies';

const CurrencyIcon = ({ symbol, size = 24, className = '' }) => {
  const src = currencyLogo(symbol);
  if (!src) {
    return (
      <div
        className={`rounded-full bg-gray-200 flex items-center justify-center text-[10px] font-bold text-gray-600 ${className}`}
        style={{ width: size, height: size }}
      >
        {String(symbol || '?').slice(0, 2)}
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={symbol}
      width={size}
      height={size}
      className={`rounded-full object-contain ${className}`}
      style={{ width: size, height: size }}
      onError={(e) => { e.target.style.display = 'none'; }}
    />
  );
};

export default CurrencyIcon;
